module.exports = require('./dist/ReactCrop');



//////////////////
// WEBPACK FOOTER
// ./~/react-image-crop/index.js
// module id = 2006
// module chunks = 0